import React from "react";
import type { ModalViewType } from "../../../../../common-deprecated/types/CommonTypes";
import type { UscInjectionModalType } from "../../../../shared-logic/utils/modalConstants";
import CalculatorError from "../common/CalculatorError";
import ModalBaseView from "../styles/organisms/Modal";
import Icon from "../../../../shared-components/lexus/styles/atoms/Icon";
import Text from "../../../../shared-components/lexus/styles/atoms/Text";
import Preloader from "../../../../shared-components/lexus/styles/molecules/Preloader";
import * as Styles from "../styles/organisms/Modal.styles";

const UscInjectionModal = (props: ModalViewType<UscInjectionModalType>): JSX.Element => {
    const { show, modalSettings } = props;
    const {
        title,
        containerId: containerID,
        onClose,
        onCloseAnimationEnd,
        injectionError,
        injectionLoading,
        className,
    } = modalSettings;

    return (
        <ModalBaseView
            modalIdType={modalSettings.type}
            onClose={onClose}
            onAnimationEnd={show ? undefined : onCloseAnimationEnd}
            show={show}
            size="external"
            disableOutsideClick
        >
            <Styles.Header noBorder>
                <Text tag="h2" variant="h6">
                    {title}
                </Text>
                <Styles.Button type="button" onClick={onClose}>
                    <Icon variant="close" />
                </Styles.Button>
            </Styles.Header>
            <Styles.Body noSpacing>
                {injectionError && <CalculatorError />}
                {injectionLoading && <Preloader data-testid="preloader" />}
                <div
                    id={containerID}
                    className={className}
                    // When using `visibility: hidden`, the correct dimensions of the container (width/height) are already available,
                    // and that is important for some calculations that are done in the container.
                    // Otherwise there will be some layout errors in the injected container.
                    style={injectionLoading ? { visibility: "hidden" } : undefined}
                />
            </Styles.Body>
        </ModalBaseView>
    );
};

export default UscInjectionModal;
